import type { Incident, PortalCall } from '../realtime/contracts';

export function resolveIncidentForCall(
  call: PortalCall,
  incidents: readonly Incident[],
): Incident | null {
  return incidents
    .filter(
      (incident) =>
        incident.isClosed === false &&
        incident.agencyViews.some((view) =>
          view.calls.some((linkedCall) => linkedCall.id === call.id),
        ),
    )
    .reduce<Incident | null>((newest, incident) => {
      if (newest === null) {
        return incident;
      }

      return Date.parse(incident.createdAtUtc) > Date.parse(newest.createdAtUtc)
        ? incident
        : newest;
    }, null);
}
